import { getElement } from '../../utils/functional'

const classes = {
  activeDrawerClass: 'drw-Drawer-active'
}

const Drawer = {
  _isOpen: false,

  init: function init ({ key }) {
    this.key = key
    
    this.els = {
      trigger: getElement(`[data-module-drawers-trigger=${key}]`),
      drawer: getElement(`[data-module-drawers-drawer=${key}]`),
      close: getElement(`[data-module-drawers-close=${key}]`)
    }
  },

  get isOpen () {
    return this._isOpen
  },

  set isOpen (val) {
    this._isOpen = val
    
    this.els.drawer.classList.toggle(classes.activeDrawerClass, val)
    
  }
}

export default Drawer
